import { IToolbarDescriptionProps } from './types';

const ToolbarDescription = ({ children }: IToolbarDescriptionProps) => {
  // Extract text content for aria-label when children is a string
  const ariaLabel = typeof children === 'string' ? children : undefined;

  return (
    <div
      className="flex items-center gap-2 text-sm font-normal text-gray-700"
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
};

export { ToolbarDescription };
